module.exports = __webpack_public_path__ + "img/v.9a814f3e.png";